import {TracciatoSorgenteTypes as TracciatoSorgentes} from '../_models/generated/tracciato-sorgente-types';

export {TracciatoSorgentes};

export const TRACCIATO_SORGENTES = [
  {value: TracciatoSorgentes.ORDINI, label: 'Ordini (Worker)'},
  {value: TracciatoSorgentes.CONTENITORI_MATERIALE, label: 'Contenitori materiale (Worker)'},
  {value: TracciatoSorgentes.CONTENITORI_PRODOTTO, label: 'Contenitori prodotto (Worker)'},
  {value: TracciatoSorgentes.CAUSALI, label: 'Causali (Worker)'},
  {value: TracciatoSorgentes.INVENTARIO, label: 'Inventario (Import)'},
  {value: TracciatoSorgentes.ANAGRAFICHE, label: 'Anagrafiche (Import)'},
  {value: TracciatoSorgentes.ORDINI_VENDITA, label: 'Ordini clienti (Import)'},
  {value: TracciatoSorgentes.ORDINI_SPEDIZIONE, label: 'Ordini spedizione (Worker)'},
  {value: TracciatoSorgentes.NC_CODICI, label: 'Codici NC (Worker)'},
  {value: TracciatoSorgentes.OPERATORI, label: 'Operatori (Worker)'},
  {value: TracciatoSorgentes.OPERATORI_BADGE, label: 'Operatori · Badge (Worker)'}
];
